export default __webpack_public_path__ + "static/media/Creating Giveaway.f2253edc.gif";